import React from 'react';
import { Box, TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';

const CustomerForm = ({ customerForm, onFormChange, onFieldBlur, fieldErrors }) => {
  const { t } = useTranslation();

  const fields = [
    { key: 'firstName', label: t('varausModal.components.firstName'), required: false },
    { key: 'lastName', label: t('varausModal.components.lastName'), required: false },
    { key: 'email', label: t('varausModal.components.email'), type: 'email', required: false },
    { key: 'phoneNumber', label: t('varausModal.components.phone'), required: false },
    { key: 'company', label: t('varausModal.components.company'), required: false },
    { key: 'address', label: t('varausModal.components.address'), required: false },
    { key: 'postalCode', label: t('varausModal.components.postalCode'), required: false },
    { key: 'city', label: t('varausModal.components.city'), required: false },
  ];

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      {fields.map(field => (
        <TextField
          key={field.key}
          label={field.label}
          type={field.type || 'text'}
          value={customerForm[field.key]}
          onChange={e => onFormChange(field.key, e.target.value)}
          onBlur={() => onFieldBlur(field.key)}
          fullWidth
          required={field.required}
          error={!!fieldErrors[field.key]}
          helperText={fieldErrors[field.key] || ''}
        />
      ))}
    </Box>
  );
};

export default CustomerForm;
